import DashboardTemplate from '../components/template/DashboardTemplate'

import Login from '../pages/LoginPage'
import Modules from '../pages/ModulesPage'
import NewModulesPage from '../pages/NewModulesPage'
import NewThemesPage from '../pages/NewThemesPage'
import NewContentsPage from '../pages/NewContentsPage'
import Themes from '../pages/ThemesPage'
import Contents from '../pages/ContentsPage'
import CreateModule from '../pages/CreateModulePage'
import CreateTheme from '../pages/CreateThemePage'
import CreateContents from '../pages/CreateContentsPage'
import VersarPage from '../pages/VersarPage'
import ThemePage from '../pages/ThemePage'
import ModulePage from '../pages/ModulePage'
import ContentPage from '../pages/ContentPage'
import ClassroomsPage from '../pages/ClassroomsPage'
import ClassroomPage from '../pages/ClassroomPage'
import PlanningGrades from '../pages/PlanningGradesPage'
import GradeTemplate from '../pages/GradeTemplatePage'
import PlanningSearch from '../pages/PlanningSearchPage'
import ThemeSchedule from '../pages/ThemeSchedulePage'
import ThemeScheduleDate from '../pages/ThemeScheduleDatePage'
import DeleteProfilePage from '../pages/DeleteProfilePage'
import Settings from '../pages/SettingsPage'
import CreateClassroom from '../pages/CreateClassroomPage'
import SettingsClassroom from '../pages/SettingsClassroomPage'
import CreateStudent from '../pages/CreateStudentPage'
import CreateTeacher from '../pages/CreateTeacherPage'
import ReactivateTeacherPage from '../pages/ReactivateTeacherPage'
import SchoolsList from '../pages/SchoolsListPage'
import Messages from '../pages/MessagesPage'
import NewMessages from '../pages/NewMessagesPage'
import Message from '../pages/MessagePage'
import MessagesInbox from '../pages/MessagesInboxPage'
import SendMessage from '../pages/SendMessagePage'
import Announcements from '../pages/AnnouncementsPage'
import AnnouncementsDetails from '../pages/AnnouncementsDetailsPage'
import AnnouncementsConfirmations from '../pages/AnnouncementsConfirmationsPage'
import Reports from '../pages/ReportsPage'
import ReportClassroom from '../pages/ReportClassroomPage'
import ReportStudent from '../pages/ReportStudentPage'
import ReportStudentByClassroom from '../pages/ReportStudentByClassroomPage'
import ReportsPageTemplate from '../pages/ReportsTemplatePage'
import UtilsPage from '../pages/UtilsPage'
import MaterialsPage from '../pages/MaterialsPage'
import CreateCoordinatorPage from '../pages/CreateCoordinatorPage'
import SocioemotionalPage from '../pages/SocioemotionalPage'
import ReactivateCoordinatorPage from '../pages/ReactivateCoordinatorPage'
import ChildrensDisplayPage from '../pages/ChildrensDisplayPage'
import HomePage from '../pages/HomePage'
import PickupPage from '../pages/PickupPage'
import PickupAuthorizationsPage from '../pages/PickupAuthorizationsPage'
import CreatePickupAuthorizationPage from '../pages/CreatePickupAuthorizationPage'
import PickupPendingPage from '../pages/PickupPendingPage'
import PickupManualPage from '../pages/PickupManualPage'
import PickupHistoryPage from '../pages/PickupHistoryPage'
import CreateDoormanPage from '../pages/CreateDoormanPage'

// access
import {
  accessVersarOnly,
  accessVersarAndSchoolAdmin,
  accessContentCreate,
  accessContentView,
  accessClassrooms,
  accessSettingsClassrooms,
  accessSettings,
  accessRooms,
  accessMessagesBase,
  accessMessagesInbox,
  accessAnnouncements,
  accessReports,
  accessReportCreate,
  accessReportStudentDetail,
  accessUtils,
  accessMaterials,
  accessHomepage,
  accessPickup,
  roles
} from '../utils/constants'

/**
 * Only logged users can access these routes
 *
 * - Major precedence when user IS LOGGED:
 *    Overwrites the same paths of the public routes
 * - No match when user IS NOT LOGGED:
 *    Render LoginPage component by default
 */

export const privateRoutes = [
  {
    path: '/modules',
    component: Modules,
    template: DashboardTemplate,
    permission: accessContentCreate
  },
  {
    path: '/socioemotional',
    component: SocioemotionalPage,
    template: DashboardTemplate,
    permission: accessContentCreate
  },
  {
    path: '/newmodules',
    component: NewModulesPage,
    template: DashboardTemplate,
    permission: accessContentCreate
  },
  {
    path: '/newmodules/create',
    component: NewModulesPage,
    template: DashboardTemplate,
    permission: accessContentCreate,
    componentAttribute: {
      isCreate: true
    }
  },
  {
    path: '/newmodules/:moduleId/edit',
    component: NewModulesPage,
    template: DashboardTemplate,
    permission: accessContentCreate,
    componentAttribute: {
      isEdit: true
    }
  },
  {
    path: `/newmodules/:moduleId/themes/create`,
    component: NewThemesPage,
    template: DashboardTemplate,
    permission: accessContentCreate,
    componentAttribute: {
      isCreate: true
    }
  },
  {
    path: '/newthemes',
    component: NewThemesPage,
    template: DashboardTemplate,
    permission: accessContentCreate
  },
  {
    path: `/newthemes/create`,
    component: NewThemesPage,
    template: DashboardTemplate,
    permission: accessContentCreate,
    componentAttribute: {
      isCreate: true
    }
  },
  {
    path: `/newthemes/:themeId/contents`,
    component: NewThemesPage,
    template: DashboardTemplate,
    permission: accessContentCreate,
    componentAttribute: {
      stepTwo: true
    }
  },
  {
    path: `/newthemes/:themeId/preview`,
    component: NewThemesPage,
    template: DashboardTemplate,
    permission: accessContentCreate,
    componentAttribute: {
      stepThree: true
    }
  },
  {
    path: `/newthemes/:themeId/edit`,
    component: NewThemesPage,
    template: DashboardTemplate,
    permission: accessContentCreate,
    componentAttribute: {
      isEdit: true
    }
  },
  {
    path: `/newcontents/:themeId/create`,
    component: NewContentsPage,
    template: DashboardTemplate,
    permission: accessContentCreate,
    componentAttribute: {
      isCreate: true
    }
  },
  {
    path: `/newcontents/:themeId/edit/:contentId`,
    component: NewContentsPage,
    template: DashboardTemplate,
    permission: accessContentCreate,
    componentAttribute: {
      isEdit: true
    }
  },
  {
    path: '/modules/create',
    component: CreateModule,
    template: DashboardTemplate,
    permission: accessContentCreate
  },
  {
    path: '/modules/:id',
    component: ModulePage,
    template: DashboardTemplate,
    permission: accessContentCreate
  },
  {
    path: '/modules/:id/edit',
    component: CreateModule,
    template: DashboardTemplate,
    permission: accessContentCreate
  },
  {
    path: '/themes',
    component: Themes,
    template: DashboardTemplate,
    permission: accessContentCreate
  },
  {
    path: '/themes/create',
    component: CreateTheme,
    template: DashboardTemplate,
    permission: accessContentCreate
  },
  {
    path: '/themes/:id/edit',
    component: CreateTheme,
    template: DashboardTemplate,
    permission: accessContentCreate
  },
  {
    path: '/themes/:id',
    component: ThemePage,
    template: DashboardTemplate,
    permission: accessContentView
  },
  {
    path: '/contents',
    component: Contents,
    template: DashboardTemplate,
    permission: accessContentCreate
  },
  {
    path: '/contents/create',
    component: CreateContents,
    template: DashboardTemplate,
    permission: accessContentCreate
  },
  {
    path: '/contents/:id',
    component: ContentPage,
    template: DashboardTemplate,
    permission: accessContentView
  },
  {
    path: '/contents/:id/edit',
    component: CreateContents,
    template: DashboardTemplate,
    permission: accessContentCreate
  },
  {
    path: '/classrooms',
    component: ClassroomsPage,
    template: DashboardTemplate,
    permission: accessClassrooms
  },
  {
    path: '/classrooms/:id',
    component: ClassroomPage,
    template: DashboardTemplate,
    permission: accessClassrooms
  },
  {
    path: '/planning/grades',
    component: PlanningGrades,
    template: DashboardTemplate,
    permission: accessVersarOnly
  },
  {
    path: '/planning/grades/:gradeId',
    component: GradeTemplate,
    template: DashboardTemplate,
    permission: accessVersarOnly
  },
  {
    path: '/planning/grades/:gradeId/search',
    component: PlanningSearch,
    template: DashboardTemplate,
    permission: accessVersarAndSchoolAdmin
  },
  {
    path: '/theme-schedule/grades',
    component: PlanningGrades,
    template: DashboardTemplate,
    permission: accessVersarAndSchoolAdmin
  },
  {
    path: '/theme-schedule/schools',
    component: SchoolsList,
    template: DashboardTemplate,
    permission: accessVersarOnly
  },
  {
    path: '/theme-schedule/schools/:schoolId/grades',
    component: PlanningGrades,
    template: DashboardTemplate,
    permission: accessVersarOnly
  },
  {
    path: '/theme-schedule/schools/:schoolId/grades/:gradeId',
    component: ThemeSchedule,
    template: DashboardTemplate,
    permission: accessVersarOnly
  },
  {
    path: '/theme-schedule/grades/:gradeId',
    component: ThemeSchedule,
    template: DashboardTemplate,
    permission: accessVersarAndSchoolAdmin
  },
  {
    path: '/theme-schedule/schools/:schoolId/grades/:gradeId/:templateId',
    component: ThemeScheduleDate,
    template: DashboardTemplate,
    permission: accessVersarOnly
  },
  {
    path: '/theme-schedule/grades/:gradeId/:templateId',
    component: ThemeScheduleDate,
    template: DashboardTemplate,
    permission: accessVersarAndSchoolAdmin
  },
  {
    path:
      '/theme-schedule/schools/:schoolId/grades/:gradeId/:templateId/search',
    component: PlanningSearch,
    template: DashboardTemplate,
    permission: accessVersarOnly
  },
  {
    path: '/theme-schedule/grades/:gradeId/:templateId/search',
    component: PlanningSearch,
    template: DashboardTemplate,
    permission: accessVersarAndSchoolAdmin
  },
  {
    path: '/settings',
    component: Settings,
    template: DashboardTemplate,
    permission: accessSettings,
    defaultFor: [roles.STUDENT, roles.PARENT, roles.NURSE, roles.PSYCHOLOGIST]
  },
  {
    path: '/settings/delete_profile',
    component: DeleteProfilePage,
    template: DashboardTemplate,
    permission: accessSettings
  },
  {
    path: '/settings/covers',
    component: Settings,
    template: DashboardTemplate,
    permission: accessVersarOnly
  },
  {
    path: '/settings/classrooms',
    component: Settings,
    template: DashboardTemplate,
    permission: accessSettingsClassrooms
  },
  {
    path: '/settings/classrooms/new',
    component: CreateClassroom,
    template: DashboardTemplate,
    permission: accessSettingsClassrooms
  },
  {
    path: '/settings/classrooms/:classId',
    component: SettingsClassroom,
    template: DashboardTemplate,
    permission: accessSettingsClassrooms
  },
  {
    path: '/settings/classrooms/:classId/edit',
    component: CreateClassroom,
    template: DashboardTemplate,
    permission: accessSettingsClassrooms
  },
  {
    path: '/settings/classrooms/:classId/students/new',
    component: CreateStudent,
    template: DashboardTemplate,
    permission: accessSettingsClassrooms
  },
  {
    path: '/settings/classrooms/:classId/students/:childId',
    component: CreateStudent,
    template: DashboardTemplate,
    permission: accessSettingsClassrooms
  },
  {
    path: '/settings/teachers',
    component: Settings,
    template: DashboardTemplate,
    permission: accessSettingsClassrooms
  },
  {
    path: '/settings/teachers/new',
    component: CreateTeacher,
    template: DashboardTemplate,
    permission: accessVersarAndSchoolAdmin
  },
  {
    path: '/settings/teachers/reactivate',
    component: ReactivateTeacherPage,
    template: DashboardTemplate,
    permission: accessVersarAndSchoolAdmin
  },
  {
    path: '/settings/teachers/:teacherId/edit',
    component: CreateTeacher,
    template: DashboardTemplate,
    permission: accessVersarAndSchoolAdmin
  },
  {
    path: '/settings/coordinator',
    component: Settings,
    template: DashboardTemplate,
    permission: accessSettingsClassrooms
  },
  {
    path: '/settings/coordinator/new',
    component: CreateCoordinatorPage,
    template: DashboardTemplate,
    permission: accessVersarAndSchoolAdmin
  },
  {
    path: '/settings/coordinator/:coordinatorId/edit',
    component: CreateCoordinatorPage,
    template: DashboardTemplate,
    permission: accessVersarAndSchoolAdmin
  },
  {
    path: '/settings/coordinator/reactivate',
    component: ReactivateCoordinatorPage,
    template: DashboardTemplate,
    permission: accessVersarAndSchoolAdmin
  },
  {
    path: '/settings/moderation',
    component: Settings,
    template: DashboardTemplate,
    permission: accessVersarAndSchoolAdmin
  },
  {
    path: '/settings/layout',
    component: Settings,
    template: DashboardTemplate,
    permission: accessVersarAndSchoolAdmin
  },
  {
    path: '/settings/historic',
    component: Settings,
    template: DashboardTemplate,
    permission: accessVersarAndSchoolAdmin
  },
  {
    path: '/settings/doorman',
    component: Settings,
    template: DashboardTemplate,
    permission: accessVersarAndSchoolAdmin
  },
  {
    path: '/settings/doorman/create',
    component: CreateDoormanPage,
    template: DashboardTemplate,
    permission: accessVersarAndSchoolAdmin,
    componentAttribute: {
      default_occupation: 14
    }
  },
  {
    path: '/settings/doorman/:id',
    component: CreateDoormanPage,
    template: DashboardTemplate,
    permission: accessVersarAndSchoolAdmin,
    componentAttribute: {
      default_occupation: 14,
      is_edit: true
    }
  },
  {
    path: '/rooms',
    component: NewMessages,
    template: DashboardTemplate,
    permission: accessRooms
  },
  {
    path: '/rooms/:chatId',
    component: NewMessages,
    template: DashboardTemplate,
    permission: accessRooms
  },
  {
    path: '/messages',
    component: Messages,
    template: DashboardTemplate,
    permission: accessMessagesBase
  },
  {
    path: '/messages/schools',
    component: SchoolsList,
    template: DashboardTemplate,
    permission: accessVersarOnly
  },
  {
    path: '/messages/inbox',
    component: MessagesInbox,
    template: DashboardTemplate,
    permission: accessMessagesBase
  },
  {
    path: '/messages/schools/:schoolId/inbox',
    component: MessagesInbox,
    template: DashboardTemplate,
    permission: accessVersarOnly
  },
  {
    path: '/messages/schools/:schoolId',
    component: Messages,
    template: DashboardTemplate,
    permission: accessVersarOnly
  },
  {
    path: '/messages/inbox/:communicationId',
    component: Message,
    template: DashboardTemplate,
    permission: accessMessagesInbox
  },
  {
    path: '/messages/schools/:schoolId/inbox/:communicationId',
    component: Message,
    template: DashboardTemplate,
    permission: accessVersarOnly
  },
  {
    path: '/messages/create',
    component: SendMessage,
    template: DashboardTemplate,
    permission: accessMessagesBase
  },
  {
    path: '/messages/schools/:schoolId/create',
    component: SendMessage,
    template: DashboardTemplate,
    permission: accessVersarOnly
  },
  {
    path: '/announcements',
    component: Announcements,
    template: DashboardTemplate,
    permission: accessAnnouncements,
    defaultFor: [roles.VERSAR_ADMIN]
  },
  {
    path: '/announcements/:eventId/details',
    component: AnnouncementsDetails,
    template: DashboardTemplate,
    permission: accessAnnouncements
  },
  {
    path: '/announcements/:eventId/confirmations',
    component: AnnouncementsConfirmations,
    template: DashboardTemplate,
    permission: accessAnnouncements
  },
  {
    path: '/reports',
    component: Reports,
    template: DashboardTemplate,
    permission: accessReports
  },
  {
    path: '/reports/create',
    component: Reports,
    template: DashboardTemplate,
    permission: accessReportCreate,
    componentAttribute: {
      isCreate: true
    }
  },
  {
    path: '/reports/:reportId/classroom',
    component: ReportClassroom,
    template: DashboardTemplate,
    permission: accessReports
  },
  {
    path: '/reports/:reportId/classroom/:reportStudentId',
    component: ReportStudent,
    template: DashboardTemplate,
    permission: accessReports
  },
  {
    path: '/reports/:reportId/classroom/all/students',
    component: ReportStudentByClassroom,
    template: DashboardTemplate,
    permission: accessReports
  },
  // {
  //   path: '/reports/:reportId/classroom/:reportStudentId/edit',
  //   component: ReportStudent,
  //   template: DashboardTemplate,
  //   permission: [roles.VERSAR_ADMIN, roles.SCHOOL_ADMIN, roles.TEACHER]
  // },
  {
    path: '/report_template/:reportTemplateId',
    component: ReportsPageTemplate,
    template: DashboardTemplate,
    permission: accessReports
  },
  {
    path: '/utils',
    component: UtilsPage,
    template: DashboardTemplate,
    permission: accessUtils
  },
  {
    path: '/materials',
    component: MaterialsPage,
    template: DashboardTemplate,
    permission: accessMaterials
  },
  {
    path: '/materials/create',
    component: MaterialsPage,
    template: DashboardTemplate,
    permission: accessMaterials,
    componentAttribute: {
      isCreate: true
    }
  },
  {
    path: '/materials/:materialId',
    component: MaterialsPage,
    template: DashboardTemplate,
    permission: accessMaterials
  },
  {
    path: '/materials/:materialId/edit',
    component: MaterialsPage,
    template: DashboardTemplate,
    permission: accessMaterials,
    componentAttribute: {
      isEdit: true
    }
  },
  {
    path: '/materials/:materialId/report',
    component: MaterialsPage,
    template: DashboardTemplate,
    permission: accessMaterials,
    componentAttribute: {
      isReport: true
    }
  },
  {
    path: '/report_student/details',
    component: ChildrensDisplayPage,
    template: DashboardTemplate,
    permission: accessReportStudentDetail
  },
  {
    path: '/homepage',
    component: HomePage,
    template: DashboardTemplate,
    permission: accessHomepage,
    defaultFor: [
      roles.SCHOOL_ADMIN,
      roles.TEACHER,
      roles.SCHOOL_MODERATOR,
      roles.COORDINATOR,
      roles.OMBUDSMAN
    ]
  },
  {
    path: '/pickup',
    component: PickupPage,
    template: DashboardTemplate,
    permission: accessPickup
  },
  {
    path: '/pickup/authorizations',
    component: PickupAuthorizationsPage,
    template: DashboardTemplate,
    permission: accessPickup
  },
  {
    path: '/pickup/authorization/create',
    component: CreatePickupAuthorizationPage,
    template: DashboardTemplate,
    permission: accessPickup
  },
  {
    path: '/pickup/authorization/:id',
    component: CreatePickupAuthorizationPage,
    template: DashboardTemplate,
    permission: accessPickup
  },
  {
    path: '/pickup/pending',
    component: PickupPendingPage,
    template: DashboardTemplate,
    permission: accessPickup
  },
  {
    path: '/pickup/manual',
    component: PickupManualPage,
    template: DashboardTemplate,
    permission: accessPickup
  },
  {
    path: '/pickup/today',
    component: PickupHistoryPage,
    template: DashboardTemplate,
    componentAttribute: {
      today: true
    },
    permission: accessPickup
  },
  {
    path: '/pickup/history',
    component: PickupHistoryPage,
    template: DashboardTemplate,
    permission: accessPickup
  }
]

/**
 * Only not logged users can access these routes
 *
 * - Precedence over same paths of private routes when user IS NOT LOGGED:
 *    Overwrites the login rendering
 * - No match when user IS LOGGED
 *    Redirect to default private route
 */
export const notLoggedRoutes = [
  {
    path: '/',
    component: VersarPage,
    onlyNoAuth: true
  },
  {
    path: '/login',
    component: Login,
    onlyNoAuth: true
  }
]

/**
 * Both logged and not logged users can access these routes
 *
 * - Minor precedence when user IS LOGGED
 *    Is overwritten by the private route with same paths
 * - Major precedence when user IS NOT LOGGED
 *    Overwrites the same paths of the private and not logged routes
 */
export const publicRoutes = [
  // {
  //   path: '/',
  //   component: Home
  // }
]
